module.exports = __webpack_public_path__ + "assets/images/project/menu/jordan-thumb.jpg?v=ddb0f379";